import { styled } from '@mui/material/styles';

export const PaypalStyled = styled('div')`
  max-height: 45px;
  border-radius: 4px;
  background: ${({ theme }) => theme.palette.payment.paypal};

  &:hover {
    background: ${({ theme }) => theme.palette.payment.paypalHover};
  }
`;
